/**
 * Whether a field validation error should be shown to the user.
 * Errors appear after the field is touched or the form has been submitted.
 */
export const shouldShowFieldError = (meta, submitAttempted) =>
  !!(meta?.error && (meta?.touched || submitAttempted));
